import { ProgressDotContainer } from './ProgressDot.styled';

interface ProgressDotProps {
  isActive?: boolean;
}

const ProgressDot = (props: ProgressDotProps) => {
  return <ProgressDotContainer isActive={props.isActive} />;
};

export default ProgressDot;
